
















import Vue from "vue";
import Component from "vue-class-component";
import { ICellRendererParams } from "ag-grid-community";
import { IPromotionUpsellModel } from "../../models";

@Component
export default class UpsellPreviewButton extends Vue {
    /**
     * Row parameter data
     * https://www.ag-grid.com/vue-data-grid/component-cell-renderer/#cell-renderer-component-3
     */
    params!: ICellRendererParams;

    get model(): IPromotionUpsellModel {
        return this.params.data as IPromotionUpsellModel;
    }

    modalOpen = false;

    previewClicked() {
        this.modalOpen = true;
    }
}
